import { retrieveBearer } from '../../../libs/sgx/api/tokenStorage';
import { CubeJSApiOptions } from '@cubejs-client/core';

// Los tableros generados con cubejs se inicializan al cargar la aplicación

const cubejsApiTokenPromise = () => Promise.resolve(retrieveBearer());

const cubejsOptions: CubeJSApiOptions = {
    apiUrl: '/api/dashboards/cubejs-api/v1',
};

export { cubejsApiTokenPromise, cubejsOptions };